import { UStyles } from "@/app/utils/UStyles";
import { PROGRESS_BAR_FILL_CLASS, ProgressBarVariant } from "./ProgressBar.logic";
import styles from "./ProgressBar.module.css";

export { ProgressBarVariant } from "./ProgressBar.logic";

type Props = {
  value: number;
  variant: ProgressBarVariant;
  isPlaceholder?: boolean;
};

export default function ProgressBar(props: Props) {
  const { value, variant, isPlaceholder } = props;

  return (
    <div className={styles.bar}>
      <div
        className={UStyles.classNames(
          styles.fill,
          isPlaceholder ? styles.fillPlaceholder : styles[PROGRESS_BAR_FILL_CLASS[variant]],
        )}
        style={isPlaceholder ? undefined : { width: `${value}%` }}
      />
    </div>
  );
}
